import { IconNameType } from '../../../components/icon'

type DeepRequired<T> = {
  [K in keyof T]-?: T[K] extends object ? DeepRequired<T[K]> : T[K]
}

export enum ETFHoldingsQuery {
  Breakdown = 'bd',
  TopTen = 'tt',
}

export enum ETFHoldingsBreakdownType {
  PieChart = 'bd-piechart',
  Map = 'bd-map',
}

export enum ETFHoldingsTopTenType {
  Table = 'tt-table',
  Map = 'tt-map',
}

export enum ETFHoldingsDialogType {
  Table = 'table',
  Map = 'map',
}

export type ETFHoldingsWidgetNavigation = {
  navType: ETFHoldingsQuery
  title: string
  viewTypes: ETFHoldingsWidgetViewType[]
}

export type ETFHoldingsDialogNavigation = {
  navType: 'dialog'
  viewTypes: ETFHoldingsDialogViewType[]
}

export type ETFHoldingsWidgetViewType = {
  icon: IconNameType
  chartType: ETFHoldingsBreakdownType | ETFHoldingsTopTenType
}

export type ETFHoldingsDialogViewType = {
  icon: IconNameType
  chartType: ETFHoldingsDialogType
}

export enum ETFHoldingDataType {
  Breakdown = 'breakdown',
  TopTen = 'topTen',
  Full = 'full',
}

export type ETFHoldingsBreakdownApiResponse = {
  rowData: ETFHoldingsBreakdownApiRowData[]
  etfTotalWeight: number
  version?: number
}

export type ETFHoldingsBreakdownApiRowData = {
  instrument: string
  data: Array<{
    sector?: string
    absoluteWeight: number
  }>
  instrumentSum: number
}

export interface ETFHoldingsBreakdownRowData extends DeepRequired<ETFHoldingsBreakdownApiRowData> {
  itemsToDisplay: number
}

export type ETFHoldingsBreakdownResponse = {
  rowData: ETFHoldingsBreakdownRowData[]
  etfTotalWeight: number
}

export type ETFHoldingsStandardApiResponse = {
  rowData: ETFHoldingsStandardApiRowData[]
  etfHoldingsTotal: number
  etfTotalWeight: number
  version?: number
}

export type ETFHoldingsStandardApiRowData = {
  ticker?: string
  name?: string
  instrument?: string
  sector?: string
  country?: string
  industry?: string
  weight?: number
  marketCap?: number
}

export interface ETFHoldingsStandardRowData
  extends DeepRequired<Omit<ETFHoldingsStandardApiRowData, 'ticker' | 'marketCap'>> {
  ticker: string | null
  marketCap?: number
  absoluteWeight: number
}

export type ETFHoldingsStandardResponse = {
  rowData: ETFHoldingsStandardRowData[]
  etfHoldingsTotal: number
  etfTotalWeight: number
}

export type GetETFHoldingsResponseDataType<T extends ETFHoldingDataType> = T extends ETFHoldingDataType.Breakdown
  ? ETFHoldingsBreakdownApiResponse
  : ETFHoldingsStandardApiResponse
